
export default{
	// baseURL:"http://192.168.10.158:924",		//此处？？
	baseURL:"http://47.93.81.30:8909",		//此处？？
	baseURL_dev:"http://192.168.10.158:8218",	//开发环境接口url
	// baseURL_dev:"http://192.168.10.158:8218/https://hbbwy.museum-edu.cn/",	//开发环境接口url
	baseURL_pro:"https://wx1.hebeimuseum.org.cn",	//生产环境接口url
	getUrlKey:function(name){
		return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
	}
}



// WEBPACK FOOTER //
// ./src/components/common/js/App.js